import Dayoffs from "./Dayoffs";

export default function DaysManager(){
    return (
        <Dayoffs />
    );
}